
const state = {
  // app_url: 'http://localhost:8080/',
  // apiUrl:'https://sirrusmodaapi.test/api/',
  // url:'https://sirrusmodaapi.test/',
  // url_files:'https://drcgnbx0z3m8q.cloudfront.net/',

  // app_url: 'https://sirrusmoda-homologacao.web.app/',
  // apiUrl:'https://homologacao.sirrusmoda.app/api/',
  // url:'https://homologacao.sirrusmoda.app/',
  // url_files:'https://drcgnbx0z3m8q.cloudfront.net/publico/',
  // is_producao: false,

  app_url: 'https://sirrusmoda.app/',
  apiUrl:'https://cloud.sirrusmoda.app/api/',
  url:'https://cloud.sirrusmoda.app/',
  url_files:'https://d2y5pwm3jaci4g.cloudfront.net/publico/',
  is_producao: true,

  empresa_url: '',
  empresa:{},
  grupos:[],
  produtosPromocao:[],
  produtosPromocaoBool:false,
  grupoPromocional: {},
  produtos:[],
  produto:{},
  pedido:{
    itens:[]
  },
  dias:[],
  empresaVerificada:false,
  imagem_zoom:""
};

const getters = {
  getValorTotalPedido: state => {

    var valorTotal = 0.00;
    state.pedido.itens.forEach(res=>{
      var valorAdicional = 0.00;
      res.adicionais.forEach( adicional=>{
        if(adicional){
          valorAdicional = parseFloat(valorAdicional) + parseFloat(adicional.valor) * (adicional.quantidade || 1);
        }
      })
      valorTotal = valorTotal + ((parseFloat(res.produto.valor) + valorAdicional) * res.quantidade);
    });
    return valorTotal.toFixed(2);

  },
  getValorTotalPedidoQualiDesconto: state => {

    var valorTotal = 0.00;
    state.pedido.itens.forEach(res=>{
      var valorAdicional = 0.00;
      res.adicionais.forEach( adicional=>{
        if(adicional){
          valorAdicional = parseFloat(valorAdicional) + parseFloat(adicional.valor) * (adicional.quantidade || 1);
        }
      })
      if(res.produto.qualificado_desconto == "S"){
        valorTotal = valorTotal + ((parseFloat(res.produto.valor) + valorAdicional) * res.quantidade);
      }
    });
    return valorTotal.toFixed(2);

  },
  GetLojaStatus: state => {
    if(state.empresa.forma_exibicao_horario == 'TABELA')
    {
      var moment = require('moment');
      var agora = new Date();
      var horas = agora.getHours();
      var minutos = agora.getMinutes();
      var status = false;
      state.empresa.horarios.forEach(res=>{
        if(res.dia == agora.getDay())
        {
          var nowTime = moment(horas + ':'+ minutos , 'hh:mm');
          var beginningTime = moment(res.abre, 'hh:mm');
          var endTime = moment(res.fecha, 'hh:mm');
          if(nowTime.isBetween(beginningTime, endTime)){
            status =  true;
          }
        }
      });
      if(!status)
        state.empresa.aberto = "N";

      return status;
    }else{
      return true;
    }
  },
  pedidoSubtotal: state => {
    var subtotal = 0.00;
    state.pedido.itens.forEach(res => {
      var valorAdicional = 0.00;
      res.adicionais.forEach(adicional => {
        if (adicional) {
          valorAdicional += parseFloat(adicional.valor) * (adicional.quantidade || 1);
        }
      });

      subtotal += (parseFloat(res.produto.valor) + valorAdicional) * res.quantidade;
    });

    return subtotal;
  },
  pedidoTotal: (state, getters) => {
    return getters.pedidoSubtotal + parseFloat(state.empresa.taxa_entrega);
  }

}

const mutations = {
  empresaVerificada (state, empresaVerificada){
    state.empresaVerificada = empresaVerificada;
  },
  grupos (state, grupos){
    state.grupos = grupos;
  },
  produtosPromocao (state, produtosPromocao){
    state.produtosPromocao = produtosPromocao;
  },
  produtosPromocaoBool (state, produtosPromocaoBool){
    state.produtosPromocaoBool = produtosPromocaoBool;
  },
  grupoPromocional (state, grupoPromocional){
    state.grupoPromocional = grupoPromocional;
  },
  dias (state, dias){
    state.dias = dias;
  },
  empresaUrl (state, empresa_url){
    state.empresa_url = empresa_url;
  },
  empresa(state, empresa) {

    document.title = "Sirrus Delivery - " + empresa.nome;

    var style = document.getElementById('cssEmpresa');

    if (!style) {
      style = document.createElement('style');
      style.id = 'cssEmpresa';
      style.type = 'text/css';
      document.getElementsByTagName('head')[0].appendChild(style);
    }

    style.innerHTML =
      '.cor-primaria-text { color: ' + empresa.cor_primaria + ' !important; } ' +
      '.cor-primaria-bg { background-color: ' + empresa.cor_primaria + ' !important; } ' +
      '.cor-primaria-border { border-color: ' + empresa.cor_primaria + ' !important; } ' +
      '.cor-primaria-divider { border-color: ' + empresa.cor_primaria + '4d !important; } ' +

      '.character-counter { color: ' + empresa.cor_primaria + ' !important; } ' +

      'input:not([type]):focus:not([readonly]), input[type=text]:not(.browser-default):focus:not([readonly]), input[type=password]:not(.browser-default):focus:not([readonly]), input[type=email]:not(.browser-default):focus:not([readonly]), input[type=url]:not(.browser-default):focus:not([readonly]), input[type=time]:not(.browser-default):focus:not([readonly]), input[type=date]:not(.browser-default):focus:not([readonly]), input[type=datetime]:not(.browser-default):focus:not([readonly]), input[type=datetime-local]:not(.browser-default):focus:not([readonly]), input[type=tel]:not(.browser-default):focus:not([readonly]), input[type=number]:not(.browser-default):focus:not([readonly]), input[type=search]:not(.browser-default):focus:not([readonly]), textarea.materialize-textarea:focus:not([readonly]) { border-bottom: 1px solid ' + empresa.cor_primaria + ' !important; -webkit-box-shadow: 0 1px 0 0 ' + empresa.cor_primaria + ' !important; box-shadow: 0 1px 0 0 ' + empresa.cor_primaria + ' !important; } ' +

      '[type="checkbox"].filled-in:not(:checked) + span:not(.lever):after { border-color: ' + empresa.cor_primaria + ' !important; } ' +
      '[type="checkbox"].filled-in:checked + span:not(.lever):after { background-color: ' + empresa.cor_primaria + ' !important; border-color: ' + empresa.cor_primaria + ' !important; } ' +
      '.switch label input[type=checkbox]:checked + .lever { background-color: ' + empresa.cor_primaria + '99 !important; } ' +
      '.switch label .lever:before { background-color: ' + empresa.cor_primaria + '26 !important; } ' +
      '.switch label input[type=checkbox]:checked + .lever:after { background-color: ' + empresa.cor_primaria + ' !important; } ' +

      '[type="radio"]:not(:checked) + span:before, [type="radio"]:not(:checked) + span:after { border: 2px solid ' + empresa.cor_primaria + ' !important; } ' +
      '[type="radio"]:checked + span:after, [type="radio"].with-gap:checked + span:after { background-color: ' + empresa.cor_primaria + ' !important; } ' +
      '[type="radio"]:checked + span:after, [type="radio"].with-gap:checked + span:before, [type="radio"].with-gap:checked + span:after { border: 2px solid ' + empresa.cor_primaria + ' !important; } ' +

      '.cor-secundaria-bg { background-color: ' + empresa.cor_secundaria + ' !important; } ' +

      '.cor-fonte-menu-lateral { color: ' + empresa.cor_cardapio_menu_fonte + ' !important; } ' +
      '.splash-cor-1 { color: ' + empresa.cor_splash_texto_1 + ' !important; } ' +
      '.splash-cor-2 { color: ' + empresa.cor_splash_texto_2 + ' !important; }';

    state.empresa = empresa;
  },
  produtos (state, produtos) {
    state.produtos = produtos;
  },
  produto (state, produto) {
    state.produto = produto;
  },
  imagem_zoom (state, imagem_zoom) {
    state.imagem_zoom = imagem_zoom;
  },
  pedido (state, pedido) {
    state.pedido = pedido;
  },
  adicionar_item_pedido (state, item) {
    state.pedido.itens.push(item);
  },
  remover_item_pedido (state, itemRemover) {
    var forDeletion = [];
    forDeletion.push(itemRemover);
    var itenspedido = state.pedido.itens.filter(item => !forDeletion.includes(item))
    state.pedido.itens = itenspedido;
  },
  remover_item_adicional_pedido(state, objetoItemAdicional){
    var forDeletion = [];
    forDeletion.push(objetoItemAdicional.adicional);

    var itenspedido = objetoItemAdicional.item.adicionais.filter(item => !forDeletion.includes(item));
    objetoItemAdicional.item.adicionais = itenspedido;

    const index = state.pedido.itens.findIndex(project => project === objetoItemAdicional.item );
    state.pedido.itens[index] = objetoItemAdicional.item;
  }
}

const actions = {

};

const delivery = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};

export default delivery;



// WEBPACK FOOTER //
// ./src/store/modules/delivery-module.js